import { render } from "./view-address-edit.vue?vue&type=template&id=6e0fda14"
import script from "./view-address-edit.vue?vue&type=script&setup=true&lang=js"
export * from "./view-address-edit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/addresses/view-address-edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e0fda14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e0fda14', __exports__)) {
    api.reload('6e0fda14', __exports__)
  }
  
  module.hot.accept("./view-address-edit.vue?vue&type=template&id=6e0fda14", () => {
    api.rerender('6e0fda14', render)
  })

}


export default __exports__